module.exports = "<div class=\"task-flag\" [ngClass]=\"{'subtask': isSubtask}\">\n  <a role=\"button\" [ngClass]=\"flagStatusCssClass()\" title=\"Flag the question for later review\" (click)=\"toggleFlag()\">\n    <div class=\"star\">\n      <div [ngClass]=\"{'icon-star-outline': hasFlaggedSubtasksAndIsNotFlagged(), 'icon-star': !hasFlaggedSubtasksAndIsNotFlagged()}\">\n        <div *ngIf=\"!isSubtask\"class=\"flagged-subtasks\" [ngClass]=\"{'extended': totalFlaggedSubtasks > 9}\">{{totalFlaggedSubtasks}}</div>\n      </div>\n    </div>\n  </a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/task-flag/task-flag.html
// module id = R4x7
// module chunks = 3